export default __webpack_public_path__ + "static/media/p9.939267f1.jpg";